// extracted by mini-css-extract-plugin
export default {"todo-item-priority":"styles_todo-item-priority__ARFU2"};